import ReceiptLayout from '@/components/Receipt/ReceiptLayout';
import ProgressBar from '@/components/common/ProgressBar';
import SendingReceiptMail from '@/components/common/SendingReceiptMail';
import TextButton from '@/components/common/TextButton';
import { COMPLETE_TEXTS } from '@/constants/complete.const';
import { routes } from '@/constants/routes.const';
import { useAppDispatch, useAppSelector } from '@/hooks/useReduxHooks';
import { IGlobalState } from '@/store';
import { ICON_CHECK_STYLED } from '@repo/assets';
import { BankCallGuide } from '@repo/components';
import { BANK_CALL_GUIDE, MAIN_NATIONS } from '@repo/constants';
import { isNationIncluded } from '@repo/utils';
import { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router';
import styled from 'styled-components';

type Params = {
  isEmailChanged?: boolean;
};
function RefundResult() {
  const history = useHistory();
  const dispatch = useAppDispatch();
  const { isEmailChanged } = useParams() as Params;
  const { nationality, isUploadRequired, refundCondition, isCashPickup } =
    useAppSelector((state) => state) as IGlobalState;
  const [sendingStatus, setSendingStatus] = useState<'IS_SENDING' | 'DEFAULT'>(
    'DEFAULT',
  );

  const goToRecipt = () => {
    if (refundCondition === 'REFUND_ONLY') {
      dispatch({ type: 'UPDATE_USER_INFO', payload: { refundAfter: false } });
      history.push(routes.home);
    } else {
      dispatch({ type: 'UPDATE_USER_INFO', payload: { refundAfter: true } });
      if (isUploadRequired) {
        history.push(routes.airportPrintReceipt);
      } else {
        history.push(routes.home, {
          scrollToReceipt: true,
        });
      }
    }
  };
  const onNavigate = (value: string) => {
    history.push(value);
  };

  useEffect(() => {
    isUploadRequired && isEmailChanged && setSendingStatus('IS_SENDING');
  }, []);

  useEffect(() => {
    dispatch({
      type: 'UPDATE_USER_INFO',
      payload: { isRefundInfoRegistered: true },
    });
  }, []);

  useEffect(() => {
    const handleBackButton = () => {
      history.push(routes.home);
    };
    window.addEventListener('popstate', handleBackButton);
    return () => {
      window.removeEventListener('popstate', handleBackButton);
    };
  }, []);

  return (
    <ReceiptLayout>
      {sendingStatus === 'IS_SENDING' && (
        <SendingReceiptMail setSendingStatus={setSendingStatus} />
      )}
      <ProgressBar percent={100} />
      <Img src={ICON_CHECK_STYLED} />
      <Title>
        {nationality === 'KOR' ? `모든 정보를 입력했습니다.` : `Completed`}
      </Title>
      <Description>
        {(() => {
          if (isCashPickup) {
            return COMPLETE_TEXTS.COMPLETE_CASH_PICKUP_TEXT;
          }
          if (isUploadRequired) {
            if (nationality === 'KOR') {
              return COMPLETE_TEXTS.COMPLETE_FORCE_TEXT_KOR;
            }
            return COMPLETE_TEXTS.COMPLETE_FORCE_CRUISE_TEXT;
          }
          if (isNationIncluded(MAIN_NATIONS, nationality)) {
            if (nationality === 'KOR') {
              return COMPLETE_TEXTS.COMPLETE_TEXT_KOR;
            }
            return COMPLETE_TEXTS.COMPLETE_MAIN_NATIONS_TEXT;
          }
          return COMPLETE_TEXTS.COMPLETE_ETC_NATIONS_TEXT;
        })()}
        {(nationality === 'CHN' || nationality === 'JPN') && (
          <BankCallGuide
            title={BANK_CALL_GUIDE[nationality].title}
            questionTitle={BANK_CALL_GUIDE[nationality].questionTitle}
            questionText={BANK_CALL_GUIDE[nationality].questionText}
            answerTitle={BANK_CALL_GUIDE[nationality].answerTitle}
            answerText={BANK_CALL_GUIDE[nationality].answerText}
          />
        )}
      </Description>
      <TextButton
        title={nationality === 'KOR' ? '홈으로' : 'Home'}
        color='#246CF6'
        bgColor='#FFFFFF'
        outline
        onClick={() => onNavigate(routes.home)}
      />
    </ReceiptLayout>
  );
}

export default RefundResult;

const Img = styled.img`
  width: 66px;
  height: 66px;
  margin: 200px auto 30px;
  transform: translateX(-4px);
  @media ${(props) => props.theme.mobile} {
    margin: 130px auto 20px;
  }
`;

const Title = styled.h2`
  color: #1856cd;
  font-size: 28px;
  line-height: 36px;
  margin-bottom: 20px;
  font-weight: 700;
  width: 410px;
  text-align: center;
  white-space: pre-wrap;
`;

const Description = styled.p`
  font-size: 14px;
  font-weight: 500;
  color: #3a3b3e;
  line-height: 150%;
  white-space: pre-wrap;
  text-align: center;
  margin-bottom: 100px;
`;

const InfoTitle = styled.span`
  display: block;
  color: #246cf6;
  font-size: 12px;
  font-weight: 600;
  line-height: 18px;
`;
